import React from 'react'
import { LinkSubcontractor } from 'src/components/link-subcontractor/LinkSubcontractor'

export const LinkSubcontractorPage = () => {
  return <LinkSubcontractor />
}
